var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SettingComponentPage',{attrs:{"title":"ログイン方法","summary":"利用者がどの方法でログインできるかを決めます。"}},[_c('AuthPolicySettings')],1)}
var staticRenderFns = []

export { render, staticRenderFns }